import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useQueryString } from "./useQueryString";

export const useRedirectToPage = (absoluteUrl: string, enabled: boolean) => {
  const navigate = useNavigate();
  const location = useLocation();

  const targetPage = useQueryString().get("target_page") || location.pathname;

  useEffect(() => {
    if (enabled)
      navigate(`${absoluteUrl}${location.search}&target_page=${targetPage}`);
  }, [enabled]);

  return null;
};
